import { ScholarSystems } from 'containers/scholarSystem';
import { useCountries } from 'containers/useCountries';
import { useUser } from '@teetsh/app/src/containers/App/context/useUser';

export function useScholarSystem(country?: string) {
  const user = useUser();
  const countryToUse = country || user?.country;
  const { sortedCountries } = useCountries();

  const scholarSystemValue = countryToUse
    ? sortedCountries.find(c => c.code === countryToUse)?.scholarSystem
    : undefined;

  const scholarSystem = scholarSystemValue
    ? ScholarSystems[scholarSystemValue]
    : undefined;

  return { scholarSystem };
}
